<template>
    <div class="animated fadeIn profile">
        <div class="row">
            <div class="col-md-3">
                <div class="card">
                    <div class="card-header"><i class="fa fa-camera"></i> {{ $t('profile.avatar') }}</div>
                    <div class="card-block avatar">
                        <div class="row">
                            <div class="col-md-12">
                                <img :src="Auth.user.profile.photo_big" alt="">
                            </div>
                            <div class="col-md-12">
                                {{ $t('profile.gravatar_change_avatar') }}
                                <a href="https://gravatar.com/" target="_blank">Gravatar.com</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- /avatar -->

            <div class="col-md-4">
                <div class="card">
                    <div class="card-header"><i class="fa fa-lock"></i> {{ $t('profile.security') }}</div>
                    <div class="card-block security">
                        <div class="form-group">
                            <div class="input-group">
                                <span class="input-group-addon"><i class="fa fa-asterisk"></i></span>
                                <input type="password" v-model="security.oldPassword"
                                       :placeholder="$t('auth.old_password')" class="form-control"
                                       :disabled="security.isLoading">
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="input-group">
                                <span class="input-group-addon"><i class="fa fa-asterisk"></i></span>
                                <input type="password" v-model="security.password" :placeholder="$t('auth.password')"
                                       class="form-control" :disabled="security.isLoading">
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="input-group">
                                <span class="input-group-addon"><i class="fa fa-asterisk"></i></span>
                                <input type="password" v-model="security.passwordRepeat"
                                       :placeholder="$t('auth.password_repeat')" class="form-control"
                                       :disabled="security.isLoading">
                            </div>
                        </div>
                        <div class="form-group-row" v-if="security.alert">
                            <div class="alert" :class="`alert-${security.alert.type ? security.alert.type : 'danger'}`">
                                {{ security.alert.message }}
                            </div>
                        </div>
                    </div>
                    <div class="card-footer">
                        <button type="submit" class="btn btn-sm btn-success" @click="changePassword"
                                :disabled="security.isLoading">{{ $t('profile.change_password') }} <i
                                class="fa fa-spinner fa-spin" aria-hidden="true" v-show="security.isLoading"></i>
                        </button>
                    </div>
                </div>
            </div>
            <!-- /security -->

            <div class="col-md-5">
                <div class="card">
                    <div class="card-header"><i class="fa fa-user"></i> {{ $t('profile.personal_information') }}</div>
                    <div class="card-block personal-information">
                        <div class="form-group row">
                            <label for="hf-login" class="col-md-3 form-control-label">{{ $t('auth.login') }}</label>
                            <div class="col-md-9">
                                <input type="text" id="hf-login" class="form-control"
                                       v-model="Auth.user.profile.username" disabled>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label for="hf-email" class="col-md-3 form-control-label">{{ $t('profile.email') }}</label>
                            <div class="col-md-9">
                                <input type="email" id="hf-email" class="form-control" v-model="personal.email"
                                       :disabled="personal.isLoading">
                            </div>
                        </div>
                        <div class="form-group row">
                            <label for="hf-first_name" class="col-md-3 form-control-label">{{ $t('profile.first_name')
                                }}</label>
                            <div class="col-md-9">
                                <input type="text" id="hf-first_name" class="form-control" v-model="personal.firstName"
                                       :disabled="personal.isLoading">
                            </div>
                        </div>
                        <div class="form-group row">
                            <label for="hf-last_name" class="col-md-3 form-control-label">{{ $t('profile.last_name')
                                }}</label>
                            <div class="col-md-9">
                                <input type="text" id="hf-last_name" class="form-control" v-model="personal.lastName"
                                       :disabled="personal.isLoading">
                            </div>
                        </div>
                        <div class="form-group-row" v-if="personal.alert">
                            <div class="alert" :class="`alert-${personal.alert.type ? personal.alert.type : 'danger'}`">
                                {{ personal.alert.message }}
                            </div>
                        </div>
                    </div>
                    <div class="card-footer">
                        <button type="submit" class="btn btn-sm btn-success" @click="saveProfile"
                                :disabled="personal.isLoading">{{ $t('verbs.save') }} <i class="fa fa-spinner fa-spin"
                                                                                         aria-hidden="true"
                                                                                         v-show="personal.isLoading"></i>
                        </button>
                    </div>
                </div>
            </div>
            <!-- /personal_information -->

            <div class="col-md-3">
                <div class="card">
                    <div class="card-header"><i class="fa fa-language"></i> {{ $t('profile.language') }}</div>
                    <div class="card-block language">
                        <div class="form-group-row">
                            <MultiSelect track-by="value" :options="language.list" :searchable="false" label="label"
                                         :allowEmpty="false"
                                         v-model="language.selected"
                                         :disabled="language.isLoading">
                            </MultiSelect>
                        </div>
                        <div class="form-group-row" v-if="language.alert">
                            <div class="alert" :class="`alert-${language.alert.type ? language.alert.type : 'danger'}`">
                                {{ language.alert.message }}
                            </div>
                        </div>
                    </div>
                    <div class="card-footer">
                        <button type="submit" class="btn btn-sm btn-success" @click="changeLanguage"
                                :disabled="language.isLoading">{{ $t('verbs.save') }} <i class="fa fa-spinner fa-spin"
                                                                                         aria-hidden="true"
                                                                                         v-show="language.isLoading"></i>
                        </button>
                    </div>
                </div>
                <div class="card">
                    <div class="card-header"><i class="fa fa-cog"></i> {{ $t('profile.for_developer') }}</div>
                    <div class="card-block">
                        <c-switch type="icon" variant="danger" v-bind="{on: '\uf00c', off: '\uf00d'}" v-model="developMode" @change="handleDevelopMode"/>
                        {{ $t('profile.developer_mode') }}
                    </div>
                    <div class="card-footer">
                    </div>
                </div>
            </div>
            <!-- /language -->
        </div>
    </div>
</template>

<script>
  import Auth from '../../api/Auth'
  import API from '../../api/API'
  import MultiSelect from 'vue-multiselect'
  import Storage from '../../api/Storage'
  import { find } from 'lodash'
  import cSwitch from '../../components/Switch.vue'

  export default {
    name: 'Profile',
    components: {
      MultiSelect,
      cSwitch
    },
    data () {
      return {
        developMode: false,
        Storage: Storage,
        Auth: Auth,
        security: {
          isLoading: false,
          password: null,
          passwordRepeat: null,
          oldPassword: null,
          alert: null
        },
        personal: {
          isLoading: false,
          email: Auth.user.profile.email,
          firstName: Auth.user.profile.first_name,
          lastName: Auth.user.profile.last_name,
          alert: null
        },
        language: {
          isLoading: null,
          list: [
            {value: 'ru', label: 'Русский'},
            {value: 'en', label: 'English'}
          ],
          selected: {},
          alert: null
        }
      }
    },
    mounted () {
      this.language.selected = find(this.language.list, {value: Storage.language})
      this.developMode = Storage.developMode
    },
    methods: {
      handleDevelopMode (event) {
        localStorage.setItem('developMode', this.developMode)
        window.location.reload()
      },
      changePassword () {
        this.security.isLoading = true
        this.security.alert = null
        if (this.security.alert === null && (!this.security.password || this.security.password.length < 6)) {
          this.security.alert = {
            message: this.$root.$t('profile.password_error_9')
          }
        }
        if (this.security.alert === null && (this.security.password !== this.security.passwordRepeat)) {
          this.security.alert = {
            message: this.$root.$t('profile.password_error_8')
          }
        }
        if (this.security.alert === null && (!this.security.oldPassword || this.security.oldPassword.length < 6)) {
          this.security.alert = {
            message: this.$root.$t('profile.password_error_10')
          }
        }
        if (this.security.alert === null) {
          API.profileChangePassword(this.security.oldPassword, this.security.password, this.security.passwordRepeat).then(() => {
            this.security.alert = {
              type: 'success',
              message: this.$root.$t('profile.password_changed')
            }
            this.security.oldPassword = null
            this.security.password = null
            this.security.passwordRepeat = null
            this.security.isLoading = null
          }).catch(response => {
            this.security.alert = {
              message: this.$root.$t(`profile.password_error_${response.body.code}`)
            }
            this.security.isLoading = null
          })
        } else {
          this.security.isLoading = null
        }
      },
      saveProfile () {
        this.personal.isLoading = true
        this.personal.alert = null
        if (this.personal.email.length === 0 || this.personal.firstName.length === 0 || this.personal.lastName.length === 0) {
          this.personal.alert = {
            message: this.$root.$t('profile.need_all')
          }
          this.personal.isLoading = false
        } else {
          API.profileUpdate(this.personal.email, this.personal.firstName, this.personal.lastName).then((response) => {
            if (!response.body.response) {
              this.personal.alert = {
                message: response.body[Object.keys(response.body)[0]][0]
              }
              this.personal.isLoading = false
            } else {
              Auth.user.profile.email = this.personal.email
              Auth.user.profile.first_name = this.personal.firstName
              Auth.user.profile.last_name = this.personal.lastName
              this.personal.alert = {
                type: 'success',
                message: this.$root.$t('profile.updated')
              }
              this.personal.isLoading = false
            }
          }).catch(response => {
            this.personal.alert = {
              message: response.body.message
            }
            this.personal.isLoading = false
          })
        }
      },
      changeLanguage () {
        this.language.isLoading = true
        API.profileChangeLanguage(this.language.selected.value).then(() => {
          this.language.alert = {
            type: 'success',
            message: this.$root.$t('profile.language_changed')
          }
          localStorage.setItem('lang', this.language.selected.value)
          window.location.reload()
          this.language.isLoading = false // да-да
        }).catch(response => {
          this.language.alert = {
            message: !response.body.message ? response.body : response.body.message
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Profile.vue?9b765e18